import { NotifyHelper } from "../../../helpers/toast";
import { eCauTrucDeThiActionsObj } from "../../action-types/de-thi/ICauTrucDeThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const cauTrucDeThiActions = {
  ...generateActions(eCauTrucDeThiActionsObj, "CAU_TRUC_DE_THI"),
  ...generateActionForKey(
    eCauTrucDeThiActionsObj,
    "CAU_TRUC_DE_THI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eCauTrucDeThiActionsObj,
    "CAU_TRUC_DE_THI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eCauTrucDeThiActionsObj,
    "CAU_TRUC_DE_THI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eCauTrucDeThiActionsObj,
    "CAU_TRUC_DE_THI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
